module.exports = __webpack_public_path__ + "img/loading_h.b2f585b3.png";